import { JsonObject, JsonProperty } from 'json2typescript'
import VAP from '@/services/models/VAP'
import DirectDebitQuote from './DirectDebitQuote'
import Endorsement from './Endorsement'
import Fee from './Fee'
import GrantedCoverItem from './GrantedCoverItem'
import Model from './Model'
import ReInsurerDocument from './ReInsurerDocument'
import Scheme from './Scheme'
import SchemeCoverDetail from './SchemeCoverDetail'
import SubscriptionResult from './SubscriptionResult'

@JsonObject('SchemeQuoteResult')
export default class SchemeQuoteResult extends Model {
  @JsonProperty('schemeName', String)
  schemeName = ''

  @JsonProperty('scheme', Scheme)
  scheme: Scheme = new Scheme()

  @JsonProperty('calculatedGrossPremiumInclIPT', Number)
  calculatedGrossPremiumInclIPT = 0

  @JsonProperty('calculatedNetPremiumExclIPT', Number)
  calculatedNetPremiumExclIPT = 0

  @JsonProperty('calculatedPremiumIPT', Number)
  calculatedPremiumIPT = 0

  @JsonProperty('calculatedGrossPremiumInclIPTAndFees', Number)
  calculatedGrossPremiumInclIPTAndFees = 0

  @JsonProperty('fees', Number)
  fees = 0

  @JsonProperty('feesBreakdown', [Fee])
  feesBreakdown: Fee[] = []

  @JsonProperty('calculatedTotalPayable', Number)
  calculatedTotalPayable = 0

  @JsonProperty('endorsements', [Endorsement])
  endorsements: Endorsement[] = []

  @JsonProperty('directDebitQuote', DirectDebitQuote)
  directDebitQuote: DirectDebitQuote = new DirectDebitQuote()

  @JsonProperty('coverLevelDetail', SchemeCoverDetail)
  coverLevelDetail: SchemeCoverDetail = new SchemeCoverDetail()

  @JsonProperty('status', String)
  status = ''

  @JsonProperty('quoteReference', String)
  quoteReference = ''

  @JsonProperty('subscriptionResult', SubscriptionResult, true)
  subscriptionResult: SubscriptionResult | null = null

  @JsonProperty('vaps', [VAP])
  vaps: VAP[] = []

  @JsonProperty('additional', Number)
  additional = 0

  @JsonProperty('grantedCoverItems', [GrantedCoverItem])
  grantedCoverItems: GrantedCoverItem[] = []

  @JsonProperty('reInsurerDocuments', [ReInsurerDocument])
  reInsurerDocuments: ReInsurerDocument[] = []
}

@JsonObject('CarSchemeQuoteResult')
export class CarSchemeQuoteResult extends SchemeQuoteResult {
  @JsonProperty('compulsoryExcess', Number)
  compulsoryExcess = 0

  @JsonProperty('noClaimsProtected', Boolean)
  noClaimsProtected = false

  @JsonProperty('ncdProtectionCost', Number)
  ncdProtectionCost = 0

  @JsonProperty('failedNCP', Boolean)
  failedNCP = false

  @JsonProperty('windscreenExcess', Number)
  windscreenExcess = false

  @JsonProperty('windscreenRepairExcess', Number)
  windscreenRepairExcess = false

  @JsonProperty('allowedToDriveOtherVehicles', Boolean)
  allowedToDriveOtherVehicles = false

  @JsonProperty('voluntaryExcess', Number)
  voluntaryExcess = 0
}

@JsonObject('PetSchemeQuoteResult')
export class PetSchemeQuoteResult extends SchemeQuoteResult {
  @JsonProperty('compulsoryExcess', Number)
  compulsoryExcess = 0

  @JsonProperty('coPayExcess', Number)
  coPayExcess = 0
}

@JsonObject('VehicleSchemeQuoteResult')
export class VehicleSchemeQuoteResult extends SchemeQuoteResult {
  @JsonProperty('compulsoryExcess', Number)
  compulsoryExcess = 0
}

@JsonObject('PropertySchemeQuoteResult')
export class PropertySchemeQuoteResult extends SchemeQuoteResult {
  @JsonProperty('buildingsCompulsoryExcess', Number)
  buildingsCompulsoryExcess = null

  @JsonProperty('subsidenceExcess', Number)
  subsidenceExcess = null

  @JsonProperty('buildingsVoluntaryExcess', Number)
  buildingsVoluntaryExcess = null

  @JsonProperty('contentsVoluntaryExcess', Number)
  contentsVoluntaryExcess = null

  @JsonProperty('contentsCompulsoryExcess', Number)
  contentsCompulsoryExcess = null

  @JsonProperty('contentsAllRiskExcess', Number)
  contentsAllRiskExcess = null

  @JsonProperty('buildingsFloodExcess', Number)
  buildingsFloodExcess = null

  @JsonProperty('buildingsWaterExcess', Number)
  buildingsWaterExcess = null

  @JsonProperty('contentsFloodExcess', Number)
  contentsFloodExcess = null

  @JsonProperty('contentsWaterExcess', Number)
  contentsWaterExcess = null
}

@JsonObject('TouringCaravanSchemeQuoteResult')
export class TouringCaravanSchemeQuoteResult extends SchemeQuoteResult {
  @JsonProperty('compulsoryExcess', Number)
  compulsoryExcess = 0

  @JsonProperty('voluntaryExcess', Number)
  voluntaryExcess = 0
}
